<template>
  <div class="p-0 m-0">
    <div v-for="(message, key) in messages" :key="key" class="center-text">
      <h6
        :class="[
          'text-center noBorderRadius inline-display mb-0',
          message.class,
        ]"
      >
        {{ message.text }}
      </h6>
    </div>
  </div>
</template>

<script>
import { numbersOnly } from "../../../lib/format";

import moment from "moment";

export default {
  name: "Status",
  props: {
    prescription_medicine_time: Object,
    medicine_check: Object,
    eventual: [String, Number],
    date: [String, Number],
  },
  data() {
    return {
      timeNow: "",
      time: "",
      messages: [],
    };
  },
  watch: {
    medicine_check: function () {
      this.handleMessages();
    },
  },
  created() {
    this.retrieve();
  },
  methods: {
    moment,
    numbersOnly,
    handleMessages() {
      let {
        timeNow,
        medicine_check,
        eventual,
        date,
        prescription_medicine_time,
      } = this;

      let time = numbersOnly(`${date}${prescription_medicine_time.time}`);

      let messages = [];

      if (medicine_check.id) {
        if (eventual != "null" && medicine_check.status == "SEPARADO") {
          if (parseInt(time) < parseInt(timeNow)) {
            messages.push({
              text: "ATRASADO",
              class: "btn-atrasado",
            });
          }
          messages.push({
            text: "SEPARADO",
            class: "btn-checado",
          });
        }

        if (eventual != "null" && medicine_check.status == "CHECADO") {
          messages.push({
            text: "CHECADO",
            class: "btn-checado",
          });
        }
      }

      if (!medicine_check.id) {
        if (eventual != "null") {
          if (parseInt(time) < parseInt(timeNow)) {
            messages.push({
              text: "ATRASADO",
              class: "btn-atrasado",
            });
          }
        } else {
          messages.push({
            text: "SOMENTE SE NECESSÁRIO",
            class: "btn-nesce",
          });
        }
        messages.push({
          text: "NÃO SEPARADO",
          class: "btn-not-separado",
        });
      }

      this.messages = messages;
    },
    retrieve() {
      this.timeNow = numbersOnly(moment().format("YYYY-MM-DD HH:mm:ss"));
      this.handleMessages();
    },
  },
};
</script>
